import { render, staticRenderFns } from "./JumpWeb.vue?vue&type=template&id=b70e087c&scoped=true&"
import script from "./JumpWeb.vue?vue&type=script&lang=js&"
export * from "./JumpWeb.vue?vue&type=script&lang=js&"
import style0 from "./JumpWeb.vue?vue&type=style&index=0&id=b70e087c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70e087c",
  null
  
)

export default component.exports